import type { RoseRocketCustomer, SheetRow } from '../types/entities';
import { formatAddress, withSyncFields } from './helpers';

export async function mapCustomer(customer: RoseRocketCustomer): Promise<SheetRow> {
  return withSyncFields({
    rr_customer_id: customer.id,
    customer_name: customer.name,
    email: customer.email || '',
    phone: customer.phone || '',
    billing_address: formatAddress(customer.billing_address),
    billing_city: customer.billing_address?.city || '',
    billing_state: customer.billing_address?.state || '',
    billing_postal_code: customer.billing_address?.postal_code || '',
    billing_country: customer.billing_address?.country || '',
    rr_created_at: customer.created_at || '',
    rr_updated_at: customer.updated_at,
  });
}
